export const reduce = (num) => {
  while (num > 22) {
    num = ((num - 1) % 22) + 1;
  }
  return num === 0 ? 22 : num;
};

export const sumDigits = (num) =>
  num.toString().split("").reduce((sum, digit) => sum + Number(digit), 0);

export const reduceToSingleDigit = (num) => {
  while (num > 9) {
    num = sumDigits(num);
  }
  return num;
};

export const calculateLifePeriods = (lifePath) => {
  const period1 = 36 - lifePath;
  return [period1, period1 + 9, period1 + 18, period1 + 27];
};

export const calculateMatrix = (day, month, year) => {
  const birthDate = new Date(year, month - 1, day);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const hasHadBirthday =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() &&
      today.getDate() >= birthDate.getDate());

  if (!hasHadBirthday) age--;

  const dayArcana = reduce(day);
  const monthArcana = reduce(month);
  const yearArcana = reduce(sumDigits(year));

  const total = sumDigits(day) + sumDigits(month) + sumDigits(year);
  const lifePath = reduceToSingleDigit(total);

  const selfRealization = reduce(dayArcana + monthArcana + yearArcana);

  const KU1 = reduce(Math.abs(dayArcana - monthArcana));
  const KU2 = reduce(Math.abs(dayArcana - yearArcana));
  const KU3 = reduce(Math.abs(KU1 - KU2));
  const KU4 = reduce(Math.abs(monthArcana - yearArcana));
  const KU5 = reduce(KU1 + KU2 + KU3 + KU4);

  const A1 = reduce(dayArcana + monthArcana);
  const A2 = reduce(dayArcana + yearArcana);
  const A3 = reduce(A1 + A2);
  const A4 = reduce(yearArcana + monthArcana);

  const periods = calculateLifePeriods(lifePath);

  return {
    lifePath,
    dayArcana,
    monthArcana,
    yearArcana,
    selfRealization,
    achievements: [A1, A2, A3, A4],
    karmicKnots: [KU1, KU2, KU3, KU4, KU5],
    periods,
    age,
  };
};